// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--03d8a";
export var footerColumn = "footer-module--footerColumn--1eb9b";
export var footerColumnLinks = "footer-module--footerColumnLinks--832fc";
export var footerColumnTitle = "footer-module--footerColumnTitle--b488d";
export var footerContent = "footer-module--footerContent--8fd00";
export var footerFooter = "footer-module--footerFooter--94f27";
export var footerWrapper = "footer-module--footerWrapper--dd13e";